import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  return (
    <div className="text-center space-y-4 mb-8">
      {/* Logo and Brand */}
      <div className="flex items-center justify-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-xl">
          <Icon name="Activity" size={24} color="white" />
        </div>
        <div className="text-left">
          <h1 className="text-2xl font-bold text-foreground">ServiceWatch</h1>
          <p className="text-sm text-muted-foreground">Outage Monitoring Platform</p>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h2 className="text-3xl font-bold text-foreground">
          Create Your Account
        </h2>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Join thousands of users monitoring service outages in real-time
        </p>
      </div>

      {/* Key Benefits */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8 max-w-2xl mx-auto">
        <div className="flex flex-col items-center space-y-2 p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full">
            <Icon name="Bell" size={18} className="text-primary" />
          </div>
          <h3 className="text-sm font-semibold text-foreground">Real-time Alerts</h3>
          <p className="text-xs text-muted-foreground text-center">
            Get notified instantly when services go down
          </p>
        </div>

        <div className="flex flex-col items-center space-y-2 p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center justify-center w-10 h-10 bg-success/10 rounded-full">
            <Icon name="MapPin" size={18} className="text-success" />
          </div>
          <h3 className="text-sm font-semibold text-foreground">Local Tracking</h3>
          <p className="text-xs text-muted-foreground text-center">
            Monitor outages specific to your location
          </p>
        </div>

        <div className="flex flex-col items-center space-y-2 p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center justify-center w-10 h-10 bg-warning/10 rounded-full">
            <Icon name="Users" size={18} className="text-warning" />
          </div>
          <h3 className="text-sm font-semibold text-foreground">Community Reports</h3>
          <p className="text-xs text-muted-foreground text-center">
            Contribute to crowd-sourced outage data
          </p>
        </div>
      </div>

      {/* Navigation Breadcrumb */}
      <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground mt-6">
        <Link to="/outage-dashboard" className="hover:text-foreground transition-colors">
          Dashboard
        </Link>
        <Icon name="ChevronRight" size={14} />
        <span className="text-foreground font-medium">Register</span>
      </div>
    </div>
  );
};

export default RegistrationHeader;